import React from 'react'
import AlumniDash from '../../Components/AlumniComponent/AlumniDash/AlumniDash'
import AddNotesForm from '../../Components/TeacherComponents/NotesShare/AddNotesForm'

function AddNotesPage() {
  return (
    <AlumniDash>
       <AddNotesForm/>
    </AlumniDash>
  )
}

export default AddNotesPage